import { __decorate } from "tslib";
// NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
import Loader from "@/components/widgets/loader.vue";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ProductsViewModel } from "@/store/models/productsApps/productViewDTO";
import ProductsModule from "@/store/modules/productsApps.module";
import addProducts, { AppsUpdateModel } from "@/store/models/productsApps/AppUpdateDTO";
import { interpret } from "xstate";
import viewProductMachine from "./machines/viewProductMachine";
setInteractionMode("passive");
let Products = /** @class */ (() => {
    let Products = class Products extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.ctaButtons = [{ routeName: "Products" }];
            this.title = "View Product";
            this.items = [
                {
                    text: "Apps List",
                },
            ];
            this.selectedViewProduct = new ProductsViewModel();
            this.selectedApps = new ProductsViewModel();
            this.selectedAddApps = new addProducts(new AppsUpdateModel());
            this.viewSelectedApps = new addProducts(new AppsUpdateModel());
            // MACHINE
            this.machine = viewProductMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        //Add
        openNewAddAppsModal() {
            this.machineService.send({ type: "ADD_APP" });
            this.selectedAddApps.productId = this.product.id;
        }
        saveApps() {
            this.validate("newAppsAddObserver").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "SAVE_APP",
                        payload: this.selectedAddApps,
                    });
                }
            });
        }
        //Update
        openEditAppsModal(appsId) {
            this.machineService.send({ type: "EDIT_APP", appsId: appsId });
        }
        SaveUpdatedApps() {
            this.validate("newAppsEditObserver").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "UPDATE_APP",
                        payload: this.apps,
                    });
                }
            });
        }
        cancelApps() {
            this.machineService.send({ type: "CANCEL_APP" });
            this.selectedAddApps = new AppsUpdateModel();
            this.selectedAddApps = Object.assign({}, this.selectedAddApps);
        }
        openViewAppsModal(appsId) {
            for (var i = 0; i < Object.keys(ProductsModule.productView.appsDTO).length; i++) {
                if (ProductsModule.productView.appsDTO[i].appsId == appsId) {
                    this.viewSelectedApps = ProductsModule.productView.appsDTO[i];
                }
            }
            this.machineService.send({ type: "VIEW_APP" });
        }
        // Computed
        get product() {
            return ProductsModule.productView;
        }
        get apps() {
            return ProductsModule.appEdit;
        }
        //Lifecycle
        created() {
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("gettingProduct") || this.state.matches("loadedProduct")) {
                    this.$bvModal.hide("add-apps");
                    this.$bvModal.hide("edit-apps");
                    this.$bvModal.hide("view-apps");
                }
                if (this.state.matches("addApp")) {
                    this.$bvModal.show("add-apps");
                }
                if (this.state.matches("editApp")) {
                    this.$bvModal.show("edit-apps");
                }
                if (this.state.matches("viewApp")) {
                    this.$bvModal.show("view-apps");
                }
            });
            this.viewProductId = Guid.parse(this.$route.params.viewProductId);
            this.machineService.machine.context.viewProductId = this.viewProductId.value;
            this.machineService.start();
        }
    };
    Products = __decorate([
        Component({
            name: "Products",
            components: {
                Layout,
                PageHeader,
                Loader,
            },
        })
    ], Products);
    return Products;
})();
export default Products;
